import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const MOBILE_MQ = "(max-width: 820px)";
const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
  (typeof window !== "undefined" && window.matchMedia && window.matchMedia(MOBILE_MQ).matches);

function getLogged() {
  try {
    if (typeof window !== "undefined" && window.__loggedWorker) return window.__loggedWorker;
    const raw = sessionStorage.getItem("loggedWorker") || localStorage.getItem("loggedWorker");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** ProtectedRoute minimalista (sin comprobar pathname).
 *  Evita loops entre /login-mobile y rutas móviles como /mobilegridapp.
 */
export default function ProtectedRoute() {
  const location = useLocation();
  const user = getLogged();

  
  const allowInvoice =
    location?.pathname === "/invoice" &&
    ((sessionStorage.getItem("invoiceAccess") || localStorage.getItem("invoiceAccess")) === "1");
if (!user && !allowInvoice) {
    return <Navigate to={isMobile() ? "/login-mobile" : "/login"} replace state={{ from: location }} />;
  }
  return <Outlet />;
}
